<template>
	<form
		class="form"
		:style="{ maxWidth: maxWidth }"
		@submit.prevent
	>
		<div class="form__content">
			<TypographyKTypographyH3
				color="var(--white)"
				font-weight="extra-bold"
				>{{ $t('auth-sign-in-title') }}</TypographyKTypographyH3
			>
			<TypographyKTypographyBody4
				class="mt-5 text-center"
				color="var(--white)"
				>{{ $t('auth-sign-in-subtitle') }}</TypographyKTypographyBody4
			>
			<UiInputPhone
				v-model="login"
				max-width="340px"
				:placeholder="$t('auth-recovery-password-input-phone-placeholder')"
				class="login"
				:label="''"
				labelColor="var(--color_font_wite_wite)"
				:error="errorField.login"
				:autocomplete="'username'"
				id="auth-username"
				name="username"
				@blur="clearError('login')"
			></UiInputPhone>
			<UiInput
				v-model="password"
				max-width="340px"
				:label="''"
				label-color="var(--color_font_wite_wite)"
				:placeholder="$t('auth-form-label-password-placeholder')"
				class="password"
				type="password"
				:autocomplete="'current-password'"
				:clearable="true"
				:showIconClear="true"
				:error="errorField.password"
				id="auth-password"
				name="password"
				@blur="clearError('password')"
			></UiInput>
		</div>
		<div class="form__footer">
			<UiIcon
				name="main-logo"
				folder="logo"
				width="128px"
				height="57px"
			/>
			<UiButton
				:color="ButtonType.primary"
				:size="ButtonSizeType.b_xl"
				class="btn__login"
				@click="loginHandler"
			>
				<TypographyKTypographyBody2
					font-type="medium"
					color="var(--color_font_wite_wite)"
					>{{ $t('auth-login-btn') }}</TypographyKTypographyBody2
				>
			</UiButton>
		</div>
		<!-- <UiButton
			:color="ButtonType.outline"
			:size="ButtonSizeType.b_xxl"
			class="btn__sign-up"
			@click="signUpHandler"
		>
			<TypographyKTypographyBody1
				font-weight="bold"
				color="var(--color_font_wite_wite)"
				>{{ $t('auth-registration-btn') }}</TypographyKTypographyBody1
			>
			<UiIcon
				name="lock_v2"
				color="var(--color_font_wite_wite)"
				height="18"
				width="20"
			/>
		</UiButton> -->
	</form>
</template>

<script setup lang="ts">
	import { validator, VALIDATE_RULES } from '~/helpers/validate';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';
	import { useNotificationStore } from '~/store/notification.store';
	import { useProfileStore } from '~/store/profile.store';

	const props = withDefaults(
		defineProps<{
			maxWidth?: string;
		}>(),
		{
			maxWidth: '341px'
		}
	);

	const router = useRouter();
	const userStore = useProfileStore();
	const notificationStore = useNotificationStore();
	const { t } = useI18n();
	const login = ref('');
	const password = ref('');
	const errorField = ref({
		login: { status: false, msg: '' },
		password: { status: false, msg: '' }
	});

	const clearError = (type: 'login' | 'password' | 'checkBoxConfirm') => {
		errorField.value = { ...errorField.value, [type]: false };
	};

	const validateHandler = () => {
		const arrayRules: Array<{
			field: string;
			value: string | boolean;
			rules: VALIDATE_RULES[];
		}> = [
			{ field: 'login', value: login.value, rules: [VALIDATE_RULES.required] },
			{ field: 'password', value: password.value, rules: [VALIDATE_RULES.required] }
		];
		arrayRules.forEach((item) => {
			errorField.value = { ...errorField.value, [item.field]: validator(item.value, item.rules)[0] };
		});
	};

	const signUpHandler = () => {
		router.push('/authorization/sign-up');
	};

	const loginHandler = () => {
		validateHandler();
		if (!Object.values(errorField.value).find((item) => item.status)) {
			userStore.authUser({ login: login.value.replace(/[^\d]/g, ''), password: password.value });
		} else {
			notificationStore.addNewAlert(t('general-error-validate-field'), 3500);
		}
	};

	onMounted(() => {});
</script>
<style lang="scss">
	#telegram-login-GlobalITTestBot__place {
		margin-top: 30px;
		height: 45px;
	}
	#telegram-login-GlobalITTestBot {
		max-height: 45px;
	}
</style>
<style scoped lang="scss">
	.form {
		display: grid;
		grid-template-rows: 1fr min-content;
		width: 100%;
		height: 100%;

		&__content {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		}

		&__footer {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-top: auto;
		}

		.footer-title {
			margin-top: 44px;
			text-align: center;
		}

		.icon__lock {
			margin-left: 5px;
		}

		.btn__registration {
			margin-top: 18px;
			width: 100%;
		}

		.btn__login {
			margin-top: 23px;
			width: 100%;
		}

		.btn__sign-up {
			margin-top: 18px;
			width: 100%;
		}

		.password-recovery {
			display: inline-block;
			width: 100%;
			margin-top: 10px;

			div {
				display: inline-block;
			}

			a {
				margin-left: 5px;
				display: inline-block;
				border-bottom: 1px solid var(--white);
			}
		}

		.login {
			margin-top: 37px;
		}

		.password {
			margin-top: 20px;
		}

		.title {
			margin-top: 8vh;
		}

		.subtitle {
			max-width: 308px;
			margin-top: 30px;
			text-align: center;
		}
	}
</style>
